var EVENT_TYPES = {
    //https://github.com/wix-private/chat-server/blob/master/chat/chat-core/src/main/scala/com/wix/corechat/domain/Event.scala
    MESSAGE_SENT: 'MessageSent',
    CHATROOM_DELETED: 'ChatroomDeleted',
    CHATROOM_CREATED: 'ChatroomCreated',
    TYPING_STARTED: 'TypingStarted',
    TYPING_STOPPED: 'TypingStopped',
    CHATROOOM_DISPLAY_DATA_UPDATED: 'ChatroomDisplayDataUpdated',
    CHATROOM_ARCHIVED: 'ChatroomArchived',
    CHATROOM_UNARCHIVED: 'ChatroomUnarchived',
    CHATROOM_READ: 'ChatroomRead',
    MESSAGE_INDICATION_UPDATE: 'MessageIndicationUpdate',
    PRESENCE_EVENT: 'Presence',
    EXTERNAL_HOST: 'ExternalHost',
};
export default EVENT_TYPES;
